import { useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Hook que busca a contagem de notificações não lidas.
 * Faz polling a cada 60 segundos para manter o badge atualizado.
 */
export function useUnreadNotifications() {
  const { isAuthenticated } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnread = useCallback(async () => {
    if (!isAuthenticated) {
      setUnreadCount(0);
      return;
    }

    try {
      interface BackendNotification {
        lida?: boolean;
        read?: boolean;
      }
      const response = await api.get<{ notifications: BackendNotification[]; total: number }>('/notificacoes');
      const notifications = response.notifications ?? [];
      const unread = notifications.filter((n) => !(n.lida ?? n.read ?? false)).length;
      setUnreadCount(unread);
    } catch {
      // Silently fail — don't break the app for a badge
    }
  }, [isAuthenticated]);

  useEffect(() => {
    fetchUnread();

    // Polling a cada 60 segundos
    const interval = setInterval(fetchUnread, 60_000);
    return () => clearInterval(interval);
  }, [fetchUnread]);

  return { unreadCount, refresh: fetchUnread };
}
